<template>
    <div>
        <!-- 标题 -->
        <div class="mq-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/messageQueueMonitor">{{ $t('alarms.queue.queue') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.monitoringSummary') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- 查询框 -->
        <div class="mq-top">
            <Row :gutter="16">
                <Col span="6">
                    <Select v-model="timeType" filterable @on-change="changeTimeType(timeType)">
                        <Option v-for="item in timeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <!-- 折线图 -->
        <Row :gutter="16">
            <Col span="6" v-for="(item,index) in list" :key="index">
                <Card :padding="8">
                    <p slot="title">{{item.title}}</p>
                    <a href="#" slot="extra" @click.prevent="changeFull(item)">
                        <Icon type="ios-expand" size="18"/>
                    </a>
                    <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
                </Card>
            </Col>
        </Row>
        <!-- 放大弹出框 -->
        <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
            <Row>
                <Col span="24">
                    <h3>{{lineTitle}}</h3>
                    <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
                </Col>
            </Row>
            <div slot="footer">
                <div>
                    <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    export default {
        name: 'MessageQueue',
        data () {
            return {
                // 放大功能
                lineTitle:'',
                isShowModal: false,
                // 折线图
                list: [{
                    id: 'cpuUtilizationAverage',
                    title:'cpuUtilization'
                },
                {
                    id: 'currentConnectionsCountAverage',
                    title:'currentConnectionsCount'
                },
                {
                    id: 'networkInSum',
                    title:'networkIn'
                },
                {
                    id: 'storePercentUsageAverage',
                    title:'storePercentUsage'
                },
                {
                    id: 'networkOut',
                    title:'networkOut'
                },
                {
                    id: 'totalConsumerCountSum',
                    title:'totalConsumerCount'
                },
                {
                    id: 'totalMessageCountSum',
                    title:'totalMessageCount'
                },
                {
                    id: 'heapUsageAverage',
                    title:'heapUsage'
                },
                {
                    id: 'totalProducerCountSum',
                    title:'totalProducerCount'
                },
                {
                    id: 'totalDequeueCountAverage',
                    title:'totalDequeueCount'
                },
                {
                    id: 'totalEnqueueCountAverage',
                    title:'totalEnqueueCount'
                },
                {
                    id: 'establishedConnectionsCountAverage',
                    title:'establishedConnectionsCount'
                },
                {
                    id: 'inactiveDurableTopicSubscribersCountAverage',
                    title:'inactiveDurableTopicSubscribersCount'
                },
                {
                    id: 'openTransactionCountAverage',
                    title:'openTransactionCount'
                },
                {
                    id: 'journalFilesForFastRecoveryAverage',
                    title:'journalFilesForFastRecovery'
                }],
                timeType:0,
                timeList:[],
                // echarts实例
                chartCpuUtilizationAverage:'',
                chartCurrentConnectionsCountAverage:'',
                chartNetworkIn:'',
                chartStorePercentUsageAverage:'',
                chartNetworkOut:'',
                chartTotalConsumerCountSum:'',
                chartTotalMessageCountSum:'',
                chartHeapUsageAverageLine:'',
                chartTotalProducerCountSum:'',
                chartTotalDequeueCount:'',
                chartTotalEnqueueCountAverageLine:'',
                chartEstablishedConnectionsCountAverageLine:'',
                chartInactiveDurableTopicSubscribersCountAverageLine:'',
                chartOpenTransactionCountAverageLine:'',
                chartJournalFilesForFastRecoveryAverageLine:'',
                cpuUtilizationAverageOption:{},
                currentConnectionsCountAverageOption:{},
                networkInSumOption:{},
                storePercentUsageAverageOption:{},
                networkOutOption:{},
                totalConsumerCountSumOption:{},
                totalMessageCountSumOption:{},
                heapUsageAverageOption:{},
                totalProducerCountSumOption:{},
                totalDequeueCountAverageOption:{},
                totalEnqueueCountAverageOption:{},
                establishedConnectionsCountAverageOption:{},
                inactiveDurableTopicSubscribersCountAverageOption:{},
                openTransactionCountAverageOption:{},
                journalFilesForFastRecoveryAverageOption:{},
                // 数组
                totalMessageCount:[],
                mqcpuUtilization:[],
                journalFilesForFastRecovery:[],
                openTransactionCount:[],
                establishedConnectionsCount:[],
                inactiveDurableTopicSubscribersCount:[],
                totalEnqueueCount:[],
                totalDequeueCount:[],
                storePercentUsage:[],
                currentConnectionsCount:[],
                heapUsage:[],
                totalConsumerCount:[],
                networkIn:[],
                networkOut:[],
                totalProducerCount:[],
                xaxisData:[]
            }
        },
        mounted: function(){
            this.queryTimeHorizon();
             // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartCpuUtilizationAverage.resize();
                self.chartCurrentConnectionsCountAverage.resize();
                self.chartNetworkIn.resize();
                self.chartStorePercentUsageAverage.resize();
                self.chartNetworkOut.resize();
                self.chartTotalConsumerCountSum.resize();
                self.chartTotalMessageCountSum.resize();
                self.chartHeapUsageAverageLine.resize();
                self.chartTotalProducerCountSum.resize();
                self.chartTotalDequeueCount.resize();
                self.chartTotalEnqueueCountAverageLine.resize();
                self.chartEstablishedConnectionsCountAverageLine.resize();
                self.chartInactiveDurableTopicSubscribersCountAverageLine.resize();
                self.chartOpenTransactionCountAverageLine.resize();
                self.chartJournalFilesForFastRecoveryAverageLine.resize();
            });
        },
        created(){
            this.checkMonitorModuleIndex();
        },
        methods: {
            /******************放大********************************/
            changeFull:function(item){
                this.isShowModal=true;
                this.lineTitle=item.title;
                this.$nextTick(() => {
                    const chartFul = this.$refs.fullChart;
                    if(chartFul){
                        const fullChart = this.$echarts.init(
                            document.getElementById("chart-part")
                        );
                        fullChart.clear();
                        // AWS
                        if(item.id=='cpuUtilizationAverage'){
                            var optionFll = this.cpuUtilizationAverageOption;
                        }else if(item.id=='currentConnectionsCountAverage'){
                            var optionFll = this.currentConnectionsCountAverageOption;
                        }else if(item.id=='networkInSum'){
                            var optionFll = this.networkInSumOption;
                        }else if(item.id=='storePercentUsageAverage'){
                            var optionFll = this.storePercentUsageAverageOption;
                        }else if(item.id=='networkOut'){
                            var optionFll = this.networkOutOption;
                        }else if(item.id=='totalConsumerCountSum'){
                            var optionFll = this.totalConsumerCountSumOption;
                        }else if(item.id=='totalMessageCountSum'){
                            var optionFll = this.totalMessageCountSumOption;
                        }else if(item.id=='heapUsageAverage'){
                            var optionFll = this.heapUsageAverageOption;
                        }else if(item.id=='totalProducerCountSum'){
                            var optionFll = this.totalProducerCountSumOption;
                        }else if(item.id=='totalDequeueCountAverage'){
                            var optionFll = this.totalDequeueCountAverageOption;
                        }else if(item.id=='totalEnqueueCountAverage'){
                            var optionFll = this.totalEnqueueCountAverageOption;
                        }else if(item.id=='establishedConnectionsCountAverage'){
                            var optionFll = this.establishedConnectionsCountAverageOption;
                        }else if(item.id=='inactiveDurableTopicSubscribersCountAverage'){
                            var optionFll = this.inactiveDurableTopicSubscribersCountAverageOption;
                        }else if(item.id=='openTransactionCountAverage'){
                            var optionFll = this.openTransactionCountAverageOption;
                        }else if(item.id=='journalFilesForFastRecoveryAverage'){
                            var optionFll = this.journalFilesForFastRecoveryAverageOption;
                        }

                        fullChart.setOption(optionFll);
                        window.addEventListener("resize", function() {
                            fullChart.resize();
                        });
                    }
                });
            },
            // 模态框取消事件
            cancel() {
                this.isShowModal = false;
            },
            /******************查询********************************/
            // 查询时间范围
            queryTimeHorizon: function(){
                this.$api.cloudWatch.queryTimeHorizon("userName",getCookie(global.cookieName))
                .then(res => {
                    this.timeList = res.data;
                })
            },
            // 通过问题类型查询案例
            checkMonitorModuleIndex: function(){
                this.$api.cloudWatch.checkMonitorModuleIndex({
                    "accountId":this.$route.query.accountId,
                    "timeHorizon":this.timeType,
                    "monitorModule":16,
                    "instanceId":this.$route.query.broker,
                    "region":this.$route.query.region
                })
                .then(res => {
                    this.totalMessageCount=res.data.totalMessageCount;
                    this.mqcpuUtilization = res.data.mqcpuUtilization;
                    this.journalFilesForFastRecovery = res.data.journalFilesForFastRecovery;
                    this.openTransactionCount = res.data.openTransactionCount;
                    this.inactiveDurableTopicSubscribersCount = res.data.inactiveDurableTopicSubscribersCount;
                    this.establishedConnectionsCount = res.data.establishedConnectionsCount;
                    this.totalEnqueueCount = res.data.totalEnqueueCount;
                    this.storePercentUsage = res.data.storePercentUsage;
                    this.currentConnectionsCount = res.data.currentConnectionsCount;
                    this.heapUsage = res.data.heapUsage;
                    this.networkIn = res.data.networkIn;
                    this.networkOut = res.data.networkOut;
                    this.totalDequeueCount = res.data.totalDequeueCount;
                    this.totalConsumerCount = res.data.totalConsumerCount;
                    this.totalProducerCount = res.data.totalProducerCount;
                    this.xaxisData = res.data.xaxisData;
                    this.init();
                })
            },
            // 切换时间
            changeTimeType:function(){
                this.checkMonitorModuleIndex();
            },
            /******************所有折线图********************************/
            init:function(){
                this.cpuUtilizationAverageLine();
                this.currentConnectionsCountAverageLine();
                this.networkInSumLine();
                this.storePercentUsageAverageLine();
                this.networkOutSumLine();
                this.totalConsumerCountSumLine();
                this.totalMessageCountSumLine();
                this.heapUsageAverageLine();
                this.totalProducerCountSumLine();
                this.totalDequeueCountAverageLine();
                this.totalEnqueueCountAverageLine();
                this.establishedConnectionsCountAverageLine();
                this.inactiveDurableTopicSubscribersCountAverageLine();
                this.openTransactionCountAverageLine();
                this.journalFilesForFastRecoveryAverageLine();
            },
            // CpuUtilization
            cpuUtilizationAverageLine:function(){
                this.chartCpuUtilizationAverage=this.$echarts.init(document.getElementById("cpuUtilizationAverage"));
                this.cpuUtilizationAverageOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['percent']
                    },
                    series: [{
                        name:'percent',
                        type:'line',
                        data:this.mqcpuUtilization,
                        itemStyle: {
                            normal: {
                                color: "#91c7ae",
                                lineStyle: {
                                    color: "#91c7ae"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartCpuUtilizationAverage.setOption(this.cpuUtilizationAverageOption)
            },
            // currentConnectionsCountAverage
            currentConnectionsCountAverageLine:function(){
                this.chartCurrentConnectionsCountAverage=this.$echarts.init(document.getElementById("currentConnectionsCountAverage"));
                this.currentConnectionsCountAverageOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['count']
                    },
                    series: [{
                        name:'count',
                        type:'line',
                        data:this.currentConnectionsCount,
                        itemStyle: {
                            normal: {
                                color: "#ceca58",
                                lineStyle: {
                                    color: "#ceca58"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartCurrentConnectionsCountAverage.setOption(this.currentConnectionsCountAverageOption)
            },
            // networkIn
            networkInSumLine:function(){
                this.chartNetworkIn=this.$echarts.init(document.getElementById("networkInSum"));
                this.networkInSumOption={
                     tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['Bytes']
                    },
                    series: [{
                        name:'Bytes',
                        type:'line',
                        data:this.networkIn,
                        itemStyle: {
                            normal: {
                                color: "#c4aaaa",
                                lineStyle: {
                                    color: "#c4aaaa"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartNetworkIn.setOption(this.networkInSumOption)
            },
            //storePercentUsage
            storePercentUsageAverageLine:function(){
              this.chartStorePercentUsageAverage=this.$echarts.init(document.getElementById("storePercentUsageAverage"));
              this.storePercentUsageAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['percent']
                },
                series: [{
                  name:'percent',
                  type:'line',
                  data:this.storePercentUsage,
                  itemStyle: {
                    normal: {
                      color: "#c23531",
                      lineStyle: {
                        color: "#c23531"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartStorePercentUsageAverage.setOption(this.storePercentUsageAverageOption)
            },
            // networkOut
            networkOutSumLine:function(){
                this.chartNetworkOut=this.$echarts.init(document.getElementById("networkOut"));
                this.networkOutOption={
                     tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['Bytes']
                    },
                    series: [{
                        name:'Bytes',
                        type:'line',
                        data:this.networkOut,
                        itemStyle: {
                            normal: {
                                color: "#2f4554",
                                lineStyle: {
                                    color: "#2f4554"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartNetworkOut.setOption(this.networkOutOption)
            },
            // totalConsumerCount
            totalConsumerCountSumLine:function(){
                this.chartTotalConsumerCountSum=this.$echarts.init(document.getElementById("totalConsumerCountSum"));
                this.totalConsumerCountSumOption={
                     tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['count']
                    },
                    series: [{
                        name:'count',
                        type:'line',
                        data:this.totalConsumerCount,
                        itemStyle: {
                            normal: {
                                color: "#61a0a8",
                                lineStyle: {
                                    color: "#61a0a8"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartTotalConsumerCountSum.setOption(this.totalConsumerCountSumOption)
            },
            // totalMessageCount
            totalMessageCountSumLine:function(){
                this.chartTotalMessageCountSum=this.$echarts.init(document.getElementById("totalMessageCountSum"));
                this.totalMessageCountSumOption={
                     tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['count']
                    },
                    series: [{
                        name:'count',
                        type:'line',
                        data:this.totalMessageCount,
                        itemStyle: {
                            normal: {
                                color: "#c23159",
                                lineStyle: {
                                    color: "#c23159"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartTotalMessageCountSum.setOption(this.totalMessageCountSumOption)
            },
            // heapUsageAverageLine
            heapUsageAverageLine:function(){
              this.chartHeapUsageAverageLine=this.$echarts.init(document.getElementById("heapUsageAverage"));
              this.heapUsageAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.heapUsage,
                  itemStyle: {
                    normal: {
                      color: "#ccc",
                      lineStyle: {
                        color: "#ccc"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartHeapUsageAverageLine.setOption(this.heapUsageAverageOption)
            },
            // totalProducerCount
            totalProducerCountSumLine:function(){
                this.chartTotalProducerCountSum=this.$echarts.init(document.getElementById("totalProducerCountSum"));
                this.totalProducerCountSumOption={
                     tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['count']
                    },
                    series: [{
                        name:'count',
                        type:'line',
                        data:this.totalProducerCount,
                        itemStyle: {
                            normal: {
                                color: "#4671D5",
                                lineStyle: {
                                    color: "#4671D5"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartTotalProducerCountSum.setOption(this.totalProducerCountSumOption)
            },
            //totalDequeueCount
            totalDequeueCountAverageLine:function(){
              this.chartTotalDequeueCount=this.$echarts.init(document.getElementById("totalDequeueCountAverage"));
              this.totalDequeueCountAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.totalDequeueCount,
                  itemStyle: {
                    normal: {
                      color: "#803500",
                      lineStyle: {
                        color: "#803500"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartTotalDequeueCount.setOption(this.totalDequeueCountAverageOption)
            },
            //totalEnqueueCount
            totalEnqueueCountAverageLine:function(){
              this.chartTotalEnqueueCountAverageLine=this.$echarts.init(document.getElementById("totalEnqueueCountAverage"));
              this.totalEnqueueCountAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.totalEnqueueCount,
                  itemStyle: {
                    normal: {
                      color: "#FF9B40",
                      lineStyle: {
                        color: "#FF9B40"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartTotalEnqueueCountAverageLine.setOption(this.totalEnqueueCountAverageOption)
            },
            // establishedConnectionsCount
            establishedConnectionsCountAverageLine:function(){
              this.chartEstablishedConnectionsCountAverageLine=this.$echarts.init(document.getElementById("establishedConnectionsCountAverage"));
              this.establishedConnectionsCountAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.establishedConnectionsCount,
                  itemStyle: {
                    normal: {
                      color: "#bebebe",
                      lineStyle: {
                        color: "#bebebe"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartEstablishedConnectionsCountAverageLine.setOption(this.establishedConnectionsCountAverageOption)
            },
            //inactiveDurableTopicSubscribersCount
            inactiveDurableTopicSubscribersCountAverageLine:function(){
              this.chartInactiveDurableTopicSubscribersCountAverageLine=this.$echarts.init(document.getElementById("inactiveDurableTopicSubscribersCountAverage"));
              this.inactiveDurableTopicSubscribersCountAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.inactiveDurableTopicSubscribersCount,
                  itemStyle: {
                    normal: {
                      color: "#2ec7c9",
                      lineStyle: {
                        color: "#2ec7c9"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartInactiveDurableTopicSubscribersCountAverageLine.setOption(this.inactiveDurableTopicSubscribersCountAverageOption)
            },
            //openTransactionCount
            openTransactionCountAverageLine:function(){
              this.chartOpenTransactionCountAverageLine=this.$echarts.init(document.getElementById("openTransactionCountAverage"));
              this.openTransactionCountAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.openTransactionCount,
                  itemStyle: {
                    normal: {
                      color: "#a0a7e6",
                      lineStyle: {
                        color: "#a0a7e6"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartOpenTransactionCountAverageLine.setOption(this.openTransactionCountAverageOption)
            },
            //journalFilesForFastRecovery
            journalFilesForFastRecoveryAverageLine:function(){
              this.chartJournalFilesForFastRecoveryAverageLine=this.$echarts.init(document.getElementById("journalFilesForFastRecoveryAverage"));
              this.journalFilesForFastRecoveryAverageOption={
                tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                },
                legend: {
                  x: 'right',
                  y: '10px',
                  data:['count']
                },
                series: [{
                  name:'count',
                  type:'line',
                  data:this.journalFilesForFastRecovery,
                  itemStyle: {
                    normal: {
                      color: "#f58db2",
                      lineStyle: {
                        color: "#f58db2"
                      }
                    }
                  }
                }],
                grid: {
                    top:'20%',
                    left: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                  {
                    type : 'category',
                    boundaryGap : false,
                    data: this.xaxisData.map(function (str) {
                      return str.replace(' ', '\n')
                    })
                  }
                ],
                yAxis : [
                  {
                    splitNumber:4,
                    type : 'value'
                  }
                ]
              }
              this.chartJournalFilesForFastRecoveryAverageLine.setOption(this.journalFilesForFastRecoveryAverageOption)
            },
            /********************************/
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.brokerId=this.$route.query.brokerId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/messageQueueDetail/',query: {id: this.id,accountId:this.accountId,brokerId:this.brokerId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .mq-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-col-span-6
    {
        margin-bottom: 20px;
    }
    .mq-top
    {
        width: 100%;
        height: 53px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>





// WEBPACK FOOTER //
// src/components/monitor/mq/message_queue_dashboard/MessageQueue.vue